import { AgentDeal, User } from '@repo/database/src/types';

export interface AgentHierarchyDto {
  user: User;
  agentDeal?: AgentDeal;
  subAgents: AgentHierarchyDto[];
  parentAgent?: {
    user: User;
    agentDeal?: AgentDeal;
  };
}

export interface SubAgentEligibilityDto {
  userId: string;
  user: User;
  isEligible: boolean;
  reason?: string;
  maxRakeSharePercentage?: number;
}
